module.exports = __webpack_public_path__ + "media/images/icons/in-c5aae726a59c8fc6fc3811bc3747aed4.svg";